import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxiosForm";
import apiRoutes from "../apiConfigs";

export const courseEditApi = createAsyncThunk(
    'auth/courses/edit',
    async (data, { rejectWithValue }) => {
        //console.log(data)
        try {

            const response = await AuthAxios.patch(
                apiRoutes.courseAction(`${data.id}/settings/update`, 0),
                data.data
            )
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const courseEditSlice = createSlice({
    name: 'course_Edit',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(courseEditApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(courseEditApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(courseEditApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const courseEditReducer = courseEditSlice.reducer